import React from "react";
import Chip from "@mui/material/Chip";
import { formatDate, formatKm, formatNumber } from "../format";
import { StatCard, ComparisonBar } from "./shared";

export const DeliveryNoteCard = ({ item, translate, money, showPlate = true }) => (
  <div className="fleetbot-card">
    <div className="fleetbot-card-title fleetbot-card-title-row">
      {item.deliveryNoteNumber}
      <Chip
        size="small"
        color={item.invoiceMade === 1 ? "success" : "warning"}
        label={
          item.invoiceMade === 1
            ? translate("fleetBotInvoiced")
            : translate("fleetBotNotInvoiced")
        }
        sx={{ height: 20, fontSize: 10 }}
      />
    </div>
    {item.accountName ? (
      <div className="fleetbot-kv">
        <span>{translate("accountName")}</span>
        <strong>{item.accountName}</strong>
      </div>
    ) : null}
    {showPlate ? (
      <div className="fleetbot-kv">
        <span>{translate("plateNumber")}</span>
        <strong>{item.plateNumber || "—"}</strong>
      </div>
    ) : null}
    <div className="fleetbot-kv">
      <span>{translate("stationName")}</span>
      <strong>{item.stationName || "—"}</strong>
    </div>
    <div className="fleetbot-kv">
      <span>{translate("workOrderNumber")}</span>
      <strong>{item.workOrderNumber || "—"}</strong>
    </div>
    <div className="fleetbot-kv">
      <span>{translate("deliverynoteDate")}</span>
      <strong>{formatDate(item.serviceDate)}</strong>
    </div>
    {item.odometer ? (
      <div className="fleetbot-kv">
        <span>{translate("odometerReading")}</span>
        <strong>{formatKm(item.odometer)}</strong>
      </div>
    ) : null}
    <div className="fleetbot-kv">
      <span>{translate("fleetBotTotalAmount")}</span>
      <strong>{money(item.amount)}</strong>
    </div>
  </div>
);

function renderDnPeriod(period = {}, translate, money, hideTitle) {
  return (
    <>
      {!hideTitle && period.label ? (
        <div className="fleetbot-section-title">{period.label}</div>
      ) : null}
      <div className="fleetbot-stats">
        <StatCard
          label={translate("fleetBotTotalDeliveryNotes")}
          value={formatNumber(period.totalDeliveryNotes)}
        />
        <StatCard
          label={translate("fleetBotTotalAmount")}
          value={money(period.totalAmount)}
          accent
        />
        <StatCard
          label={translate("fleetBotInvoicedAmount")}
          value={money(period.invoicedAmount)}
        />
        <StatCard
          label={translate("fleetBotNonInvoicedAmount")}
          value={money(period.nonInvoicedAmount)}
        />
      </div>
    </>
  );
}

export function renderDeliveryNotes(questionId, data, { translate, money }) {
  if (questionId === "dnCurrentMonth" || questionId === "dnLastMonth") {
    const period =
      questionId === "dnCurrentMonth"
        ? data.summary?.currentMonth
        : data.summary?.lastMonth;
    const items = period?.items || [];

    return (
      <>
        <div className="fleetbot-section-title">{period?.label}</div>
        <div className="fleetbot-list">
          {items.map((item) => (
            <DeliveryNoteCard
              key={item.id || item.deliveryNoteNumber}
              item={item}
              translate={translate}
              money={money}
            />
          ))}
        </div>
        <div className="fleetbot-section-title">
          {translate("fleetBotDeliveryNoteSummary")}
        </div>
        {renderDnPeriod(period, translate, money, true)}
        <ComparisonBar
          spent={period?.invoicedAmount}
          saved={period?.nonInvoicedAmount}
          spentLabel={translate("fleetBotInvoicedAmount")}
          savedLabel={translate("fleetBotNonInvoicedAmount")}
          savedTone="pending"
        />
      </>
    );
  }

  if (questionId === "pendingDeliveryNotes") {
    const items = data.list || [];
    const summary = data.summary || {};

    return (
      <>
        <div className="fleetbot-list">
          {items.map((item) => (
            <DeliveryNoteCard
              key={item.id || item.deliveryNoteNumber}
              item={item}
              translate={translate}
              money={money}
            />
          ))}
        </div>
        <div className="fleetbot-section-title">
          {translate("fleetBotDeliveryNoteSummary")}
        </div>
        {renderDnPeriod(summary, translate, money, true)}
        <ComparisonBar
          spent={summary.invoicedAmount}
          saved={summary.nonInvoicedAmount}
          spentLabel={translate("fleetBotInvoicedAmount")}
          savedLabel={translate("fleetBotNonInvoicedAmount")}
          savedTone="pending"
        />
      </>
    );
  }

  if (questionId === "deliveryNoteSummary") {
    const summary = data.summary || {};
    return (
      <>
        {summary.label ? (
          <div className="fleetbot-section-title">{summary.label}</div>
        ) : null}
        <div className="fleetbot-stats">
          <StatCard
            label={translate("fleetBotTotalDeliveryNotes")}
            value={formatNumber(summary.totalDeliveryNotes)}
          />
          <StatCard
            label={translate("fleetBotTotalAmount")}
            value={money(summary.totalAmount)}
            accent
          />
          <StatCard
            label={translate("fleetBotInvoicedAmount")}
            value={money(summary.invoicedAmount)}
          />
          <StatCard
            label={translate("fleetBotNonInvoicedAmount")}
            value={money(summary.nonInvoicedAmount)}
          />
        </div>
        <ComparisonBar
          spent={summary.invoicedAmount}
          saved={summary.nonInvoicedAmount}
          spentLabel={translate("fleetBotInvoicedAmount")}
          savedLabel={translate("fleetBotNonInvoicedAmount")}
          savedTone="pending"
        />
      </>
    );
  }

  return null;
}
